import { useEffect, useState } from 'react';
import MonitoringWindowInfo from '../../monitoring-window-info/MonitoringWindowInfo';

interface Props {
  locationId: number;
}

export function ProgressiveMonitoringWindow({ locationId }: Props) {
  const [fullText, setFullText] = useState<string>('');

  // Get the full monitoring text from the original component
  useEffect(() => {
    // This is a simplified version - in practice you'd want to replicate the monitoring logic
    // For now, we'll use a basic Active/Inactive state
    setFullText('MW: Active (09:00-17:00)');
  }, [locationId]);

  const getProgressiveText = (full: string) => {
    if (full.includes('outside'))
      return { medium: 'MW: Inactive', small: 'Inactive' };
    if (full.includes('No monitoring'))
      return { medium: 'MW: None', small: 'None' };
    return { medium: 'MW: Active', small: 'Active' };
  };

  const progressive = getProgressiveText(fullText);

  return (
    <>
      {/* @xl+ - Full text from original component */}
      <div className="@xl:block hidden">
        <MonitoringWindowInfo locationId={locationId} />
      </div>

      {/* @lg - Slightly abbreviated */}
      <div className="@xl:hidden @lg:block hidden">
        <MonitoringWindowInfo locationId={locationId} />
      </div>

      {/* @md - Compact */}
      <div className="@lg:hidden @md:block hidden">{progressive.medium}</div>

      {/* @sm and below - Minimal */}
      <div className="@md:hidden">{progressive.small}</div>
    </>
  );
}

export default ProgressiveMonitoringWindow;
